<template>
  <div class="home">
    <navbar :is-active="6"></navbar>
    <div class="body form-page-body">
      <MesasSidebar active="mesas" />
      <div class="body__containt form-page-content">
        <div class="page__title form-page-title">
          <open-arrow></open-arrow>
          <div class="page__title-text">
            <h2>Editar mesa</h2>
            <p class="page__lead">Actualiza los datos de la mesa y gestiona su código QR.</p>
          </div>
        </div>

        <form class="form-card" @submit.prevent="save">
          <div class="form-card__header">
            <div class="form-card__icon">
              <i class="fas fa-chair"></i>
            </div>
            <div>
              <h3>Datos de la mesa</h3>
              <p>Los campos con * son obligatorios.</p>
            </div>
          </div>

          <div class="form-grid">
            <label class="field" :class="{ 'field--error': activeClass && !table_number }">
              <span class="field__label">Número de mesa *</span>
              <input type="text" v-model="table_number" maxlength="10" @keypress="onlynumber" placeholder="Ej. 1">
              <span class="field__hint" v-if="activeClass && !table_number">Ingresa el número</span>
            </label>

            <label class="field" :class="{ 'field--error': activeClass && !table_name }">
              <span class="field__label">Nombre de mesa *</span>
              <input type="text" v-model="table_name" maxlength="150" placeholder="Ej. Mesa terraza">
              <span class="field__hint" v-if="activeClass && !table_name">Ingresa el nombre</span>
            </label>

            <div class="field">
              <span class="field__label">Estado</span>
              <div class="status-toggle">
                <button type="button" :class="{ active: table_status === '1' }" @click="table_status = '1'">Activa</button>
                <button type="button" :class="{ active: table_status === '0' }" @click="table_status = '0'">Inactiva</button>
              </div>
            </div>

            <label class="field field--full">
              <span class="field__label">Descripción <em>(opcional)</em></span>
              <textarea v-model="table_description" rows="3" placeholder="Ubicación, capacidad u observaciones"></textarea>
            </label>
          </div>

          <div class="meta-row">
            <div class="meta-item">
              <span>UUID</span>
              <strong>{{ table_uuid || '-' }}</strong>
            </div>
            <div class="meta-item">
              <span>Registro</span>
              <strong>{{ dateFormat(register_date) }}</strong>
            </div>
            <div class="meta-item">
              <span>Última actualización</span>
              <strong>{{ dateFormat(update_date) || '-' }}</strong>
            </div>
          </div>

          <div class="form-actions">
            <button type="button" class="btn btn--ghost" @click="cancel" :disabled="saving">
              <i class="fa fa-times"></i> Cancelar
            </button>
            <button type="submit" class="btn btn--primary" :disabled="saving">
              <i class="fa fa-check"></i> {{ saving ? 'Guardando...' : 'Guardar cambios' }}
            </button>
          </div>
        </form>

        <section class="qr-panel">
          <h3>Código QR</h3>
          <p class="qr-panel__hint">El QR contiene el UUID de la mesa para el menú público.</p>
          <div class="qr-panel__body">
            <img v-if="qrImageUrl" :src="qrImageUrl" alt="QR Mesa" />
            <div class="qr-panel__actions">
              <button type="button" class="btn btn--secondary" @click="downloadQr">
                <i class="fas fa-download"></i> Descargar QR
              </button>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Navbar from '@/components/NavBar.vue'
import MesasSidebar from '@/components/MesasSidebar.vue'
import OpenArrow from '@/components/OpenArrow.vue'
import { dateFormat } from '@/utils/formats'
import '@/static/css/form-card.css'

export default {
  name: 'ShowMesa',
  components: {
    Navbar,
    MesasSidebar,
    OpenArrow
  },
  data() {
    return {
      id: null,
      table_name: '',
      table_number: '',
      table_description: '',
      table_status: '1',
      table_uuid: '',
      register_date: '',
      update_date: '',
      activeClass: false,
      saving: false,
      qrImageUrl: ''
    }
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push('/login')
      return
    }
    this.id = this.$route.query.id
    if (!this.id) {
      this.$router.push('/mesas')
      return
    }
    this.getRow()
  },
  beforeUnmount() {
    this.revokeQrUrl()
  },
  methods: {
    dateFormat,
    onlynumber(evt) {
      evt = evt || window.event
      const charCode = evt.which ? evt.which : evt.keyCode
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault()
      }
    },
    revokeQrUrl() {
      if (this.qrImageUrl) {
        URL.revokeObjectURL(this.qrImageUrl)
        this.qrImageUrl = ''
      }
    },
    async getRow() {
      const res = await axios.get('general/table/' + this.id)
      if (res.data.success && res.data.data) {
        const row = res.data.data
        this.table_name = row.table_name
        this.table_number = String(row.table_number)
        this.table_description = row.table_description || ''
        this.table_status = String(row.table_status)
        this.table_uuid = row.table_uuid
        this.register_date = row.created_at
        this.update_date = row.updated_at
        this.loadQr()
      }
    },
    async loadQr() {
      try {
        this.revokeQrUrl()
        const response = await axios.get('general/table/' + this.id + '/qr', {
          params: { view: 1 },
          responseType: 'blob'
        })
        this.qrImageUrl = URL.createObjectURL(response.data)
      } catch (e) {
        this.$swal({
          icon: 'error',
          title: 'No se pudo visualizar el QR',
          showConfirmButton: false,
          timer: 2000
        })
      }
    },
    async downloadQr() {
      try {
        const response = await axios.get('general/table/' + this.id + '/qr', {
          responseType: 'blob'
        })
        const url = URL.createObjectURL(response.data)
        const link = document.createElement('a')
        link.href = url
        link.download = 'mesa-' + this.table_number + '-' + this.table_uuid + '.png'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        URL.revokeObjectURL(url)
      } catch (e) {
        this.$swal({
          icon: 'error',
          title: 'No se pudo descargar el QR',
          showConfirmButton: false,
          timer: 2000
        })
      }
    },
    cancel() {
      this.$router.push('/mesas')
    },
    async save() {
      if (!this.table_name || !this.table_number) {
        this.activeClass = true
        this.$swal({
          icon: 'error',
          title: 'Completar los datos correctamente',
          showConfirmButton: false,
          timer: 2000
        })
        return
      }

      this.saving = true
      const data = {
        table_name: this.table_name,
        table_number: parseInt(this.table_number, 10),
        table_description: this.table_description || null,
        table_status: parseInt(this.table_status, 10)
      }

      try {
        const res = await axios.put('general/table/' + this.id, data)
        if (res.data.success) {
          this.$swal({
            position: 'center',
            icon: 'success',
            title: 'Mesa actualizada correctamente',
            showConfirmButton: false,
            timer: 2000
          })
          this.$router.push('/mesas')
        } else {
          this.$swal({
            icon: 'error',
            title: res.data.message || 'Ocurrio un error',
            showConfirmButton: false,
            timer: 2500
          })
        }
      } catch (e) {
        const message = (e.response && e.response.data && e.response.data.message)
          ? e.response.data.message
          : 'Ocurrio un error'
        this.$swal({
          icon: 'error',
          title: message,
          showConfirmButton: false,
          timer: 2500
        })
      } finally {
        this.saving = false
      }
    }
  }
}
</script>
